import type { ThemePreference } from "@chat-yai/shared/admin-types";
import { usePreferences } from "@/contexts/PreferencesContext";
import { Icon } from "./Icon";

const ORDER: ThemePreference[] = ["light", "auto", "dark"];

// 3-state segmented theme toggle (light / auto / dark). "auto" follows the
// OS preference. Persisted via PATCH /admin/me/preferences.
export function ThemeToggle(): JSX.Element {
  const { prefs, setTheme, resolvedTheme } = usePreferences();

  return (
    <div
      className="seg"
      role="radiogroup"
      aria-label="Theme"
      data-testid="theme-toggle"
      data-resolved-theme={resolvedTheme}
    >
      {ORDER.map((opt) => {
        const active = prefs.theme === opt;
        const label = opt === "auto" ? "Auto" : opt === "dark" ? "Dark" : "Light";
        const icon = opt === "dark" ? "moon" : opt === "light" ? "sun" : "settings";
        return (
          <button
            key={opt}
            type="button"
            role="radio"
            aria-checked={active}
            className={active ? "active" : ""}
            onClick={() => setTheme(opt)}
            title={`Theme: ${label}`}
            data-testid={`theme-toggle-${opt}`}
            style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
          >
            <Icon name={icon} size={12} />
            {label}
          </button>
        );
      })}
    </div>
  );
}
